import { GetQueryResponse } from "@/types/global";
import { API_URLS } from "@/utils/constant/api.constant";
import { TIME_CONFIG } from "@/utils/constant/global.constant";
import { C_API } from "@/utils/helper/api";
import { useQuery } from "@tanstack/react-query";

export const getConfig = async (params: any): Promise<GetQueryResponse> => {
  try {
    const response = await C_API.get(API_URLS.CONFIG.GET, { params });
    if (response.status === 200) {
      return response.data?.data;
    }
    throw new Error("Failed to fetch config");
  } catch (error) {
    throw error instanceof Error ? error : new Error("An error occurred while fetching config");
  }
};

export const useFetchConfig = (key: string, userType: string) => {
  return useQuery<GetQueryResponse, Error>({
    queryKey: ["config", key, userType],
    queryFn: () => getConfig({ Key: key }),
    refetchInterval: 0,
    staleTime: Infinity,
    gcTime: TIME_CONFIG.M[10],
    retry: 3,
    enabled: !!key,
  });
};
